import React, { PureComponent } from 'react';
import Dropdown from '../standardAttributes/Dropdown';
import { updateFeetPosition } from '../../../helper/scene';

export default class FeetAndCasters extends PureComponent {
  updateState = (value, importState, newAppState) => {
    const {
      appApi,
      claraApi,
      actions,
      configuration,
      attributeName,
      activeTab,
    } = this.props;
    const { blockDependOn } = appApi.config.getAttribute(attributeName);

    let parent;
    try {
      parent = configuration[blockDependOn[0][0]].modelId;
    } catch (e) {
      throw new Error(
        `Can't get parent nodeId for attribute ${attributeName}!`
      );
    }
    newAppState = actions.addModel(
      importState,
      { tab: activeTab, attribute: attributeName, value, parent },
      newAppState
    );
    newAppState = actions.setConfiguration(
      {
        attribute: attributeName,
        value: { ...importState, value },
      },
      newAppState
    );
    updateFeetPosition(claraApi, newAppState);
    return newAppState;
  };
  render() {
    return <Dropdown {...this.props} updateState={this.updateState} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/FeetAndCasters.js